// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393391414723",
  numero_telefono: "tel:+393391414723",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',
  urlImageMedia: 'http://localhost/assets/media/',


  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  */

  urlWeb: 'https://laboratoriofergola.discentya.it/',
  urlMaterialeDidattico: 'https://laboratoriofergola.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://laboratoriofergola.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://laboratoriofergola.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://laboratoriofergola.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://laboratoriofergola.discentya.it/api/',

  urlStampa: 'https://laboratoriofergola.discentya.it/stampe/',

  urlAttestati: 'https://laboratoriofergola.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://laboratoriofergola.discentya.it/pages/certificate/',
  urlImagePartners: 'https://laboratoriofergola.discentya.it/assets/media/partners/',
  urlImageMedia: 'https://laboratoriofergola.discentya.it/assets/media/',
};

